/**
 * @file   去二层弹框
 * @create macaiqi 2025/04/30
 * @update
 */
import React from "react";
import qec from "../../assets/images/qec.png";

export default function TalkShade({ setShow, handleFloorChange }) {
  return (
    <div className="shade  animate__animated animate__fadeIn animate__fast">
      <i
        className="close"
        onClick={() => {
          setShow();
        }}></i>
      <img src={qec} alt="" />
      <div
        className="slbtn"
        onClick={() => {
          handleFloorChange(1);
          setShow();
        }}></div>
      <div
        className="closebtn gg"
        onClick={() => {
          setShow();
        }}></div>
    </div>
  );
}
